document.documentElement.classList.remove("no-js");

const closeDetailsOutside = (event) => {
  document
    .querySelectorAll("details[open][data-close-outside]")
    .forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute("open");
    });
};

const closeCollectionFiltersOutside = (event) => {
  document
    .querySelectorAll(".collection-filter[open]")
    .forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute("open");
    });
};

const getProductShareData = (share) => ({
  title: share.dataset.shareTitle || document.title,
  text: share.dataset.shareTitle || document.title,
  url: window.location.href,
});

const setProductShareStatus = (share, message) => {
  const status = share.querySelector("[data-share-status]");
  if (status) status.textContent = message;
};

const copyProductLink = async (share) => {
  const url = getProductShareData(share).url;
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
  } else {
    const input = document.createElement("textarea");
    input.value = url;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.appendChild(input);
    input.select();
    if (!document.execCommand("copy")) throw new Error("Copy failed");
    input.remove();
  }
  setProductShareStatus(share, "Lien copié.");
};

const shareProductNatively = async (share) => {
  try {
    await navigator.share(getProductShareData(share));
  } catch (error) {
    if (error.name === "AbortError") return;
    share.open = true;
    setProductShareStatus(share, "Choisissez une option de partage.");
  }
};

const showGalleryMedia = (gallery, mediaId) => {
  if (!gallery || !mediaId) return;
  const target = gallery.querySelector(`[data-gallery-media="${mediaId}"]`);
  if (!target) return;

  gallery.querySelectorAll("[data-gallery-media]").forEach((media) => {
    media.hidden = media !== target;
  });
  gallery.querySelectorAll("[data-gallery-target]").forEach((button) => {
    button.setAttribute(
      "aria-current",
      button.dataset.galleryTarget === mediaId ? "true" : "false",
    );
  });
};

const updateFreeShippingMessage = (productRoot, option, available) => {
  const message = productRoot?.querySelector("[data-product-shipping-message]");
  if (!message) return;

  const thresholdCents = Number(message.dataset.thresholdCents || 0);
  const priceCents = Number(option.dataset.priceCents || 0);
  const shippingText = message.querySelector("[data-product-shipping-text]");
  const text =
    priceCents >= thresholdCents
      ? message.dataset.freeShippingText
      : message.dataset.standardShippingText;

  if (shippingText) shippingText.textContent = text || "";
  message.hidden = !available || thresholdCents <= 0 || !text;
};

const updateVariant = (form) => {
  const option = form.querySelector("[data-variant-select]")
    ?.selectedOptions[0];
  if (!option) return;

  const productRoot = form.closest("[data-product-root]");
  const addButtons = productRoot?.querySelectorAll("[data-add-to-cart]") || [];
  const prices = productRoot?.querySelectorAll("[data-product-price]") || [];
  const comparePrices =
    productRoot?.querySelectorAll("[data-product-compare-price]") || [];
  const availability = productRoot?.querySelector(
    "[data-product-availability]",
  );
  const availabilityText = productRoot?.querySelector(
    "[data-product-availability-text]",
  );
  const available = option.dataset.available === "true";

  prices.forEach((price) => {
    price.textContent = option.dataset.price || "";
  });
  comparePrices.forEach((comparePrice) => {
    comparePrice.textContent = option.dataset.comparePrice || "";
    comparePrice.hidden = !option.dataset.comparePrice;
  });
  addButtons.forEach((addButton) => {
    addButton.disabled = !available;
    const label = available ? "Ajouter au panier" : "Indisponible";
    const addButtonText = addButton.querySelector("[data-add-to-cart-text]");
    if (addButtonText) addButtonText.textContent = label;
    else addButton.textContent = label;
  });
  if (availability) {
    availability.classList.toggle("product-availability--out", !available);
    if (availabilityText) {
      availabilityText.textContent = available
        ? availability.dataset.inStockText || "En stock"
        : availability.dataset.outOfStockText || "Temporairement indisponible";
    }
  }
  updateFreeShippingMessage(productRoot, option, available);
  showGalleryMedia(
    productRoot?.querySelector("[data-product-gallery]"),
    option.dataset.mediaId,
  );
  if (option.dataset.url && window.history.replaceState)
    window.history.replaceState({}, "", option.dataset.url);
};

const selectVariantFromOptions = (form) => {
  const select = form.querySelector("[data-variant-select]");
  const optionsRoot = form.querySelector("[data-product-options]");
  if (!select || !optionsRoot) return;

  const chosen = [
    ...optionsRoot.querySelectorAll("[data-option-input]:checked"),
  ]
    .sort(
      (a, b) => Number(a.dataset.optionInput) - Number(b.dataset.optionInput),
    )
    .map((input) => input.value);

  chosen.forEach((value, index) => {
    const label = optionsRoot.querySelector(
      `[data-option-selected="${index + 1}"]`,
    );
    if (label) label.textContent = value;
  });

  const key = chosen.join(" ~ ");
  const match = [...select.options].find(
    (option) => option.dataset.options === key,
  );
  if (!match) return;

  select.value = match.value;
  updateVariant(form);
};

const updateConditionalPersonalization = (form) => {
  const group = form.querySelector("[data-conditional-personalization]");
  if (!group) return;

  const selectedOption = [
    ...form.querySelectorAll("[data-option-input]:checked"),
  ].find(
    (input) => input.dataset.optionInput === group.dataset.optionPosition,
  );
  const input = group.querySelector('input[name^="properties["]');
  if (!input) return;

  const active = Boolean(
    selectedOption?.value.startsWith(group.dataset.triggerValue || ""),
  );
  group.classList.toggle("product-personalization--disabled", !active);
  group.setAttribute("aria-disabled", active ? "false" : "true");
  input.disabled = !active;
  input.required = active;
  input.setAttribute("aria-required", active ? "true" : "false");
  input.placeholder = active ? "" : input.dataset.disabledPlaceholder || "";
  if (!active) input.value = "";
};

const initConditionalPersonalization = () => {
  document.querySelectorAll("[data-product-form]").forEach((form) => {
    updateConditionalPersonalization(form);
  });
};

const submitStickyProductForm = (button) => {
  const productRoot = button.closest("[data-product-root]");
  const form = productRoot?.querySelector("[data-product-form]");
  const primaryButton = form?.querySelector('[name="add"]');
  if (!form || !primaryButton || button.disabled) return;

  const invalidField = [...form.elements].find(
    (field) => !field.disabled && !field.checkValidity(),
  );
  if (invalidField) {
    invalidField.scrollIntoView({ behavior: "smooth", block: "center" });
    window.setTimeout(() => {
      invalidField.focus({ preventScroll: true });
      invalidField.reportValidity();
    }, 350);
    return;
  }

  form.requestSubmit(primaryButton);
};

const clampQuantity = (input, delta) => {
  // Le panier autorise 0, qui vaut suppression de la ligne ; la fiche produit
  // impose 1. On suit donc l’attribut plutôt qu’un plancher codé en dur.
  const min = input.min === "" ? 1 : Number(input.min);
  const max = input.max ? Number(input.max) : Infinity;
  const next = Math.min(
    max,
    Math.max(min, (Number(input.value) || min) + delta),
  );
  input.value = String(next);
  input.dispatchEvent(new Event("change", { bubbles: true }));
};

const updateRecommendationsControls = (section) => {
  const rail = section.querySelector("[data-recommendations-rail]");
  const controls = section.querySelector("[data-recommendations-controls]");
  if (!rail || !controls) return;

  const overflows = rail.scrollWidth - rail.clientWidth > 4;
  controls.hidden = !overflows;
  if (!overflows) return;

  const max = rail.scrollWidth - rail.clientWidth;
  controls.querySelector('[data-recommendations-scroll="-1"]').disabled =
    rail.scrollLeft <= 2;
  controls.querySelector('[data-recommendations-scroll="1"]').disabled =
    rail.scrollLeft >= max - 2;
};

const getRecommendationScrollTarget = (rail, direction) => {
  const items = Array.from(rail.querySelectorAll(":scope > li"));
  if (!items.length) return rail.scrollLeft;

  const current = rail.scrollLeft;
  const firstOffset = items[0].offsetLeft;
  const positions = items.map((item) => item.offsetLeft - firstOffset);
  const tolerance = 2;
  if (direction > 0) {
    const next = positions.find((position) => position > current + tolerance);
    return next ?? rail.scrollWidth - rail.clientWidth;
  }

  const previous = positions
    .filter((position) => position < current - tolerance)
    .pop();
  return previous ?? 0;
};

const initRecommendations = () => {
  document
    .querySelectorAll("[data-product-recommendations]")
    .forEach((section) => {
      updateRecommendationsControls(section);
      // Les visuels des cartes arrivent après le premier calcul : sans ce second
      // passage, `scrollWidth` est mesuré trop tôt et les flèches restent masquées.
      window.requestAnimationFrame(() =>
        updateRecommendationsControls(section),
      );
      section.querySelectorAll("img").forEach((image) => {
        if (image.complete) return;
        image.addEventListener(
          "load",
          () => updateRecommendationsControls(section),
          { once: true },
        );
      });

    });
};

const activateTab = (tab) => {
  const root = tab.closest("[data-product-tabs]");
  if (!root) return;

  root.querySelectorAll('[role="tab"]').forEach((item) => {
    const selected = item === tab;
    item.setAttribute("aria-selected", selected ? "true" : "false");
    item.tabIndex = selected ? 0 : -1;
    const panel = root.querySelector(
      `#${CSS.escape(item.getAttribute("aria-controls"))}`,
    );
    if (panel) panel.hidden = !selected;
  });
};

document.addEventListener("click", closeDetailsOutside);
document.addEventListener("click", closeCollectionFiltersOutside);

document.addEventListener(
  "toggle",
  (event) => {
    const filter = event.target;
    if (!filter.matches?.(".collection-filter") || !filter.open) return;
    filter
      .closest(".collection-filters")
      ?.querySelectorAll(".collection-filter[open]")
      .forEach((details) => {
        if (details !== filter) details.removeAttribute("open");
      });
  },
  true,
);

document.addEventListener("click", (event) => {
  const closeCollectionFilterButton = event.target.closest(
    "[data-close-collection-filter]",
  );
  if (closeCollectionFilterButton) {
    const filter = closeCollectionFilterButton.closest(".collection-filter");
    filter?.removeAttribute("open");
    filter?.querySelector(":scope > summary")?.focus();
    return;
  }

  const tab = event.target.closest('[data-product-tabs] [role="tab"]');
  if (tab) activateTab(tab);
});

document.addEventListener("keydown", (event) => {
  const tab = event.target.closest('[data-product-tabs] [role="tab"]');
  if (!tab) return;

  const tabs = [
    ...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]'),
  ];
  const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
  let next = null;

  if (step) next = tabs[(tabs.indexOf(tab) + step + tabs.length) % tabs.length];
  else if (event.key === "Home") next = tabs[0];
  else if (event.key === "End") next = tabs[tabs.length - 1];
  if (!next) return;

  event.preventDefault();
  activateTab(next);
  next.focus();
});

// Le panier applique la nouvelle quantité sans attendre le bouton de mise à
// jour ; un court délai laisse le temps d’enchaîner plusieurs clics.
let cartUpdateTimer = null;
const scheduleCartUpdate = (form) => {
  window.clearTimeout(cartUpdateTimer);
  cartUpdateTimer = window.setTimeout(() => {
    form
      .querySelector("[data-cart-update]")
      ?.setAttribute("disabled", "disabled");
    if (form.requestSubmit)
      form.requestSubmit(form.querySelector("[data-cart-update]"));
    else form.submit();
  }, 700);
};

document.addEventListener("change", (event) => {
  if (event.target.matches("[data-quantity-input]")) {
    const min = Number(event.target.min) || 0;
    const value = Number(event.target.value);
    if (!Number.isFinite(value) || value < min)
      event.target.value = String(min);
  }

  const cartForm = event.target.closest("[data-cart-form]");
  if (cartForm && event.target.matches("[data-quantity-input]")) {
    scheduleCartUpdate(cartForm);
    return;
  }

  const form = event.target.closest("[data-product-form]");
  if (!form) return;
  if (event.target.matches("[data-variant-select]")) updateVariant(form);
  if (event.target.matches("[data-option-input]"))
    selectVariantFromOptions(form);
  updateConditionalPersonalization(form);
});

document.addEventListener("click", (event) => {
  const stickyAddButton = event.target.closest("[data-sticky-add-to-cart]");
  if (stickyAddButton) {
    submitStickyProductForm(stickyAddButton);
    return;
  }

  const shareTrigger = event.target.closest("[data-share-trigger]");
  if (shareTrigger && navigator.share) {
    event.preventDefault();
    shareProductNatively(shareTrigger.closest("[data-product-share]"));
    return;
  }

  const copyButton = event.target.closest("[data-share-copy]");
  if (copyButton) {
    copyProductLink(copyButton.closest("[data-product-share]")).catch(() => {
      setProductShareStatus(
        copyButton.closest("[data-product-share]"),
        "Impossible de copier le lien.",
      );
    });
    return;
  }

  const arrow = event.target.closest("[data-recommendations-scroll]");
  if (arrow) {
    const section = arrow.closest("[data-product-recommendations]");
    const rail = section?.querySelector("[data-recommendations-rail]");
    if (rail) {
      const direction = Number(arrow.dataset.recommendationsScroll);
      rail.scrollTo({
        left: getRecommendationScrollTarget(rail, direction),
        behavior: "smooth",
      });
    }
    return;
  }

  const step = event.target.closest("[data-quantity-step]");
  if (step) {
    const input = step
      .closest("[data-quantity-stepper]")
      ?.querySelector("[data-quantity-input]");
    if (input) clampQuantity(input, Number(step.dataset.quantityStep));
    return;
  }

  const trigger = event.target.closest("[data-gallery-target]");
  if (!trigger) return;
  showGalleryMedia(
    trigger.closest("[data-product-gallery]"),
    trigger.dataset.galleryTarget,
  );
});

document.addEventListener("keydown", (event) => {
  const share = event.target.closest("[data-product-share]");
  if (event.key !== "Escape") return;

  const openedFilter = document.querySelector(".collection-filter[open]");
  if (openedFilter) {
    openedFilter.removeAttribute("open");
    openedFilter.querySelector(":scope > summary")?.focus();
    return;
  }

  if (!share?.open) return;
  share.open = false;
  share.querySelector(":scope > summary")?.focus();
});

window.addEventListener("resize", () => {
  document
    .querySelectorAll("[data-product-recommendations]")
    .forEach(updateRecommendationsControls);
});

// `scroll` ne remonte pas : on l’intercepte en phase de capture.
document.addEventListener(
  "scroll",
  (event) => {
    const rail = event.target.closest?.("[data-recommendations-rail]");
    const section = rail?.closest("[data-product-recommendations]");
    if (section) updateRecommendationsControls(section);
  },
  true,
);

// FAQ - ouverture et fermeture animées
//
// Un `<details>` fermé ne rend pas son contenu, donc aucune transition ne peut
// démarrer. On pilote donc les deux sens : à l’ouverture, on ouvre puis on
// maintient la hauteur à zéro le temps d’une image avant de relâcher ; à la
// fermeture, on anime vers zéro et on ne referme qu’à la fin.
// Chaque entrée reste indépendante : plusieurs peuvent être ouvertes ensemble.
const FAQ_FALLBACK_DELAY = 450;

document.addEventListener("click", (event) => {
  const summary = event.target.closest("[data-faq-item] > summary");
  if (!summary) return;

  const item = summary.parentElement;
  const answer = item.querySelector("[data-faq-answer]");
  if (!answer) return;

  event.preventDefault();

  if (item.open) {
    if (item.dataset.faqState === "closing") return;
    item.dataset.faqState = "closing";

    const finish = () => {
      if (item.dataset.faqState !== "closing") return;
      item.open = false;
      delete item.dataset.faqState;
    };

    answer.addEventListener(
      "transitionend",
      (transition) => {
        if (transition.propertyName === "grid-template-rows") finish();
      },
      { once: true },
    );
    // Filet lorsque les animations sont désactivées et qu’aucun événement ne vient.
    window.setTimeout(finish, FAQ_FALLBACK_DELAY);
    return;
  }

  item.open = true;
  item.dataset.faqState = "opening";
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      if (item.dataset.faqState === "opening") delete item.dataset.faqState;
    });
  });
});

// Avis Judge.me - pages suivantes
//
// Le métachamp `judgeme.widget` ne contient que la première page du widget,
// soit cinq avis. Les suivantes viennent de l’API publique de Judge.me, celle
// que son propre widget appelle pour paginer : pas de jeton, même balisage.
// Le rendu reste maison ; on ne réutilise que les données.
const JUDGEME_ENDPOINT = "https://api.judge.me/reviews/reviews_for_widget";

const relativeAge = (raw) => {
  const parsed = new Date(String(raw).replace(" UTC", "Z").replace(" ", "T"));
  if (Number.isNaN(parsed.getTime())) return "";

  const days = Math.floor((Date.now() - parsed.getTime()) / 86400000);
  if (days < 1) return "Aujourd'hui";
  if (days === 1) return "Hier";
  if (days < 7) return `Il y a ${days} jours`;
  if (days < 14) return "Il y a 1 semaine";
  if (days < 31) return `Il y a ${Math.floor(days / 7)} semaines`;
  if (days < 62) return "Il y a 1 mois";
  if (days < 365) return `Il y a ${Math.floor(days / 30)} mois`;
  if (days < 730) return "Il y a 1 an";
  return `Il y a ${Math.floor(days / 365)} ans`;
};

// Les étoiles sont clonées depuis un exemplaire déjà rendu par Liquid, pour ne
// pas dupliquer le tracé SVG dans le JavaScript.
const buildStars = (score, sample) => {
  if (!sample) return null;
  const stars = sample.cloneNode(true);
  const fill = stars.querySelector(".rating-stars__fill");
  const ratio = Math.max(0, Math.min(5, Number(score) || 0)) / 5;
  if (fill) fill.style.width = `${ratio * 100}%`;
  stars.setAttribute("role", "img");
  stars.setAttribute("aria-label", `${score} étoiles sur 5`);
  return stars;
};

const reviewTime = (raw) => {
  const parsed = new Date(String(raw).replace(" UTC", "Z").replace(" ", "T"));
  return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
};

const reviewScore = (source) =>
  Number(source.querySelector(".jdgm-rev__rating")?.dataset.score || 0);

const buildReviewPhotos = (source, author) => {
  const pictures = [...source.querySelectorAll(".jdgm-rev__pic-link")];
  if (!pictures.length) return null;

  const gallery = document.createElement("div");
  gallery.className = "reviews__photos";
  gallery.setAttribute("aria-label", "Photos de l'avis");

  pictures.forEach((picture, index) => {
    const thumbnail = picture.querySelector(".jdgm-rev__pic-img");
    const pictureUrl = picture.dataset.mfpSrc || picture.href;
    const thumbnailUrl = thumbnail?.dataset.src || thumbnail?.src;
    if (!pictureUrl || !thumbnailUrl) return;

    const link = document.createElement("a");
    link.className = "reviews__photo";
    link.href = pictureUrl;
    link.target = "_blank";
    link.rel = "nofollow noopener";
    link.dataset.reviewPhoto = "";
    link.dataset.reviewPhotoAlt = author
      ? `Photo ${index + 1} de l'avis de ${author}`
      : `Photo ${index + 1} de cet avis`;
    link.setAttribute(
      "aria-label",
      author
        ? `Agrandir la photo ${index + 1} de l'avis de ${author}`
        : `Agrandir la photo ${index + 1} de cet avis`,
    );

    const image = document.createElement("img");
    image.src = thumbnailUrl;
    image.alt = "";
    image.width = 80;
    image.height = 80;
    image.loading = "lazy";
    image.decoding = "async";
    link.append(image);
    gallery.append(link);
  });

  return gallery.children.length ? gallery : null;
};

// Les avis épinglés restent prioritaires. Chaque groupe est ensuite trié du
// plus récent au plus ancien, rendu serveur compris.
const sortReviewList = (list) => {
  const items = [...list.children];
  if (items.length < 2) return;

  items
    .map((item) => ({
      item,
      pinned: item.dataset.reviewPinned === "true",
      time: reviewTime(item.dataset.reviewDate || ""),
    }))
    .sort(
      (first, second) =>
        Number(second.pinned) - Number(first.pinned) ||
        second.time - first.time,
    )
    .forEach(({ item }) => list.append(item));
};

const limitReviewList = (list, limit) => {
  if (!Number.isFinite(limit)) return;
  [...list.children].slice(limit).forEach((item) => item.remove());
};

const buildReviewItem = (source, starsSample, showReplies) => {
  const text = (selector) =>
    source.querySelector(selector)?.textContent?.trim() || "";
  const body = source.querySelector(".jdgm-rev__body")?.innerHTML?.trim() || "";
  const title = text(".jdgm-rev__title");
  if (!body && !title) return null;

  const item = document.createElement("li");
  item.className = "reviews__item";
  if (source.dataset.reviewId)
    item.dataset.reviewId = source.dataset.reviewId;

  const rawDate =
    source.querySelector(".jdgm-rev__timestamp")?.dataset.content || "";
  if (rawDate) item.dataset.reviewDate = rawDate;

  const isPinned = Boolean(source.querySelector(".jdgm-rev__pinned"));
  if (isPinned) item.dataset.reviewPinned = "true";

  const head = document.createElement("div");
  head.className = "reviews__item-head";

  const score = reviewScore(source) || 5;
  const stars = buildStars(score, starsSample);
  if (stars) head.append(stars);

  if (isPinned) {
    const sample = document.querySelector(".reviews__pinned");
    const badge = sample
      ? sample.cloneNode(true)
      : document.createElement("span");
    badge.hidden = false;
    if (!sample) {
      badge.className = "reviews__pinned";
      badge.textContent = "Épinglé";
    }
    head.append(badge);
  }

  if (source.dataset.verifiedBuyer === "true") {
    // Cloné lui aussi, pour garder l’icône du badge rendu par Liquid.
    const sample = document.querySelector(".reviews__verified");
    const badge = sample
      ? sample.cloneNode(true)
      : document.createElement("span");
    badge.hidden = false;
    if (!sample) {
      badge.className = "reviews__verified";
      badge.textContent = "Vérifié";
    }
    head.append(badge);
  }

  const age = relativeAge(rawDate);
  if (age) {
    const date = document.createElement("span");
    date.className = "reviews__date";
    date.textContent = age;
    head.append(date);
  }

  item.append(head);

  if (title) {
    const heading = document.createElement("p");
    heading.className = "reviews__item-title";
    heading.textContent = title;
    item.append(heading);
  }

  if (body) {
    const content = document.createElement("div");
    content.className = "reviews__item-text";
    content.innerHTML = body;
    item.append(content);
  }

  const author = text(".jdgm-rev__author");
  const photos = buildReviewPhotos(source, author);
  if (photos) item.append(photos);

  if (author) {
    const byline = document.createElement("p");
    byline.className = "reviews__author";
    byline.textContent = author;
    item.append(byline);
  }

  const reply = showReplies
    ? source.querySelector(".jdgm-rev__reply-content")?.textContent?.trim()
    : "";
  if (reply) {
    const replyWrapper = document.createElement("div");
    replyWrapper.className = "reviews__reply";

    const replyHeading = document.createElement("p");
    replyHeading.className = "reviews__reply-heading";
    replyHeading.textContent = "Réponse de CrazyPrint";

    const replyContent = document.createElement("div");
    replyContent.className = "reviews__reply-content";
    replyContent.textContent = reply;

    replyWrapper.append(replyHeading, replyContent);
    item.append(replyWrapper);
  }

  return item;
};

const loadRemainingReviews = async (list) => {
  if (list.dataset.judgemeLoaded === "true") return;
  list.dataset.judgemeLoaded = "true";

  const shop = list.dataset.shop;
  const productId = list.dataset.productId;
  if (!shop || !productId) {
    // Rien à charger, mais le rendu serveur mérite tout de même son tri.
    sortReviewList(list);
    return;
  }

  // Les étoiles sont clonées depuis la liste quand le serveur en a rendu ;
  // sinon, depuis n’importe quel exemplaire de la page - le résumé de note en
  // fournit toujours un.
  const starsSample =
    list.querySelector(".rating-stars") ||
    document.querySelector(".rating-stars");
  const limit = Number(list.dataset.limit) || Infinity;
  const ratingFilter = Number(list.dataset.ratingFilter) || 0;
  const showReplies = list.dataset.showReplies === "true";
  const maxPages = Number(list.dataset.maxPages) || 20;
  let page = Number(list.dataset.page) || 0;
  sortReviewList(list);
  const reviewItemsById = new Map(
    [...list.children]
      .filter((item) => item.dataset.reviewId)
      .map((item) => [item.dataset.reviewId, item]),
  );
  const pendingItems = Number.isFinite(limit)
    ? [...list.children].slice(limit)
    : [];
  pendingItems.forEach((item) => item.remove());

  // `finally` garantit le tri quelle que soit la façon dont la boucle s’arrête :
  // dernière page, borne de sécurité, ou échec réseau. La limite d'affichage
  // n'est appliquée qu'après ce tri global afin de conserver les plus récents.
  try {
    // Garde-fou : Judge.me renvoie une page vide en fin de liste, mais on borne
    // tout de même le nombre d’appels.
    for (let guard = 0; guard < maxPages; guard += 1) {
      page += 1;
      const url = `${JUDGEME_ENDPOINT}?url=${encodeURIComponent(shop)}&shop_domain=${encodeURIComponent(shop)}&platform=shopify&page=${page}&product_id=${encodeURIComponent(productId)}`;

      let payload;
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        payload = await response.json();
      } catch {
        return;
      }

      const parsed = new DOMParser().parseFromString(
        payload.html || "",
        "text/html",
      );
      const reviews = parsed.querySelectorAll(".jdgm-rev");
      if (!reviews.length) return;

      reviews.forEach((review) => {
        if (ratingFilter && reviewScore(review) !== ratingFilter) return;
        const reviewId = review.dataset.reviewId;
        const item = buildReviewItem(review, starsSample, showReplies);
        if (!item) return;

        const existingItem = reviewId
          ? reviewItemsById.get(reviewId)
          : null;
        const pendingIndex = existingItem
          ? pendingItems.indexOf(existingItem)
          : -1;
        if (pendingIndex >= 0) pendingItems[pendingIndex] = item;
        else if (existingItem) existingItem.replaceWith(item);
        else list.append(item);

        if (reviewId) reviewItemsById.set(reviewId, item);
      });
    }
  } finally {
    list.append(...pendingItems);
    sortReviewList(list);
    limitReviewList(list, limit);
  }
};

const loadFeaturedReviews = async (section) => {
  if (section.dataset.featuredReviewsReady === "true") return;
  section.dataset.featuredReviewsReady = "true";

  const list = section.querySelector("[data-featured-reviews-list]");
  const loading = section.querySelector("[data-featured-reviews-loading]");
  const empty = section.querySelector("[data-featured-reviews-empty]");
  if (!list) return;

  const sources = [
    ...section.querySelectorAll("[data-featured-review-source]"),
  ].filter(
    (source, index, all) =>
      source.dataset.productId &&
      all.findIndex(
        (candidate) =>
          candidate.dataset.productId === source.dataset.productId,
      ) === index,
  );

  await Promise.all(sources.map(loadRemainingReviews));

  const limit = Number(section.dataset.limit) || 3;
  const items = sources
    .flatMap((source) => [...source.children])
    .sort(
      (first, second) =>
        reviewTime(second.dataset.reviewDate || "") -
        reviewTime(first.dataset.reviewDate || ""),
    )
    .slice(0, limit);

  items.forEach((item) => {
    item.classList.add("featured-reviews__card");
    list.append(item);
  });

  list.setAttribute("aria-busy", "false");
  if (loading) loading.hidden = true;
  if (empty) empty.hidden = items.length > 0;
};

// Modale générique : `<dialog>` fournit le piège à focus, la touche Échap et
// l’inertie de l’arrière-plan ; on n’ajoute que l’ouverture, la fermeture au
// clic sur le fond et le verrouillage du défilement de la page.
const closeModal = (modal) => {
  if (!modal) return;
  modal.close();
};

const ensureReviewPhotoModal = () => {
  const existing = document.querySelector("[data-review-photo-modal]");
  if (existing) return existing;

  const modal = document.createElement("dialog");
  modal.className = "modal review-photo-modal";
  modal.dataset.modal = "";
  modal.dataset.reviewPhotoModal = "";
  modal.setAttribute("aria-label", "Photo de l'avis agrandie");
  modal.innerHTML = `
    <button class="modal__close review-photo-modal__close" type="button" data-modal-close aria-label="Fermer">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.9"/></svg>
    </button>
    <img class="review-photo-modal__image" alt="">
  `;
  document.body.append(modal);
  watchModalState(modal);
  return modal;
};

document.addEventListener("click", (event) => {
  const reviewPhoto = event.target.closest("[data-review-photo]");
  if (reviewPhoto) {
    const modal = ensureReviewPhotoModal();
    const image = modal.querySelector(".review-photo-modal__image");
    if (modal.showModal && image) {
      event.preventDefault();
      image.src = reviewPhoto.href;
      image.alt = reviewPhoto.dataset.reviewPhotoAlt || "Photo de l'avis";
      modal.showModal();
      document.body.classList.add("modal-open");
    }
    return;
  }

  const opener = event.target.closest("[data-modal-open]");
  if (opener) {
    const modal = document.getElementById(opener.dataset.modalOpen);
    if (modal?.showModal) {
      event.preventDefault();
      modal.showModal();
      modal
        .querySelectorAll("[data-judgeme-more]")
        .forEach(loadRemainingReviews);
    }
    return;
  }

  const closer = event.target.closest("[data-modal-close]");
  if (closer) {
    closeModal(closer.closest("[data-modal]"));
    return;
  }

  // Sur le fond, `event.target` est le dialog lui-même et non son contenu.
  if (event.target.matches?.("[data-modal]")) closeModal(event.target);
});

document.addEventListener("shopify:section:load", () => {
  document.body.classList.toggle(
    "modal-open",
    Boolean(document.querySelector("[data-modal][open]")),
  );
});

const watchModalState = (modal) => {
  modal.addEventListener("close", () => {
    if (!document.querySelector("[data-modal][open]"))
      document.body.classList.remove("modal-open");
  });
};

const initModals = () => {
  document.querySelectorAll("[data-modal]").forEach((modal) => {
    if (modal.dataset.modalReady === "true") return;
    modal.dataset.modalReady = "true";
    watchModalState(modal);
  });

  document.querySelectorAll("[data-modal-open]").forEach((opener) => {
    if (opener.dataset.modalOpenReady === "true") return;
    opener.dataset.modalOpenReady = "true";
    opener.addEventListener("click", () => {
      if (document.getElementById(opener.dataset.modalOpen)?.open)
        document.body.classList.add("modal-open");
    });
  });
};

// Une ancre dont la cible est absente de la page serait un lien mort : on la
// remplace alors par son propre texte.
const pruneDeadAnchors = () => {
  document.querySelectorAll("[data-anchor-guard]").forEach((anchor) => {
    const target = anchor.getAttribute("href");
    if (target && document.querySelector(target)) return;
    const plain = document.createElement("span");
    plain.className = anchor.className;
    plain.textContent = anchor.textContent;
    anchor.replaceWith(plain);
  });
};

// Les listes d’avis hors modale se remplissent au chargement ; celles des
// modales attendent leur ouverture, pour ne pas appeler Judge.me inutilement.
const initInlineReviews = () => {
  document.querySelectorAll("[data-judgeme-more]").forEach((list) => {
    if (list.closest("[data-modal]")) return;
    loadRemainingReviews(list);
  });
};

const initFeaturedReviews = () => {
  document
    .querySelectorAll("[data-featured-reviews]")
    .forEach(loadFeaturedReviews);
};

const initNavigationDropdowns = () => {
  document.querySelectorAll("[data-nav-dropdown]").forEach((dropdown) => {
    if (dropdown.dataset.navDropdownReady === "true") return;
    dropdown.dataset.navDropdownReady = "true";

    const summary = dropdown.querySelector(":scope > summary");
    if (!summary) return;

    const syncExpandedState = () => {
      summary.setAttribute("aria-expanded", dropdown.open ? "true" : "false");
    };

    dropdown.addEventListener("toggle", syncExpandedState);
    dropdown.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !dropdown.open) return;
      dropdown.open = false;
      summary.focus();
    });

    if (dropdown.classList.contains("header__dropdown")) {
      dropdown.addEventListener("pointerenter", (event) => {
        if (event.pointerType === "mouse") dropdown.open = true;
      });
      dropdown.addEventListener("pointerleave", (event) => {
        if (
          event.pointerType === "mouse" &&
          !dropdown.contains(document.activeElement)
        )
          dropdown.open = false;
      });
    }

    syncExpandedState();
  });
};

const initTheme = () => {
  initNavigationDropdowns();
  initRecommendations();
  initConditionalPersonalization();
  initModals();
  initInlineReviews();
  initFeaturedReviews();
  pruneDeadAnchors();
};

if (document.readyState === "loading")
  document.addEventListener("DOMContentLoaded", initTheme);
else initTheme();

document.addEventListener("shopify:section:load", initTheme);
